<script lang="ts">
	import classNames from "classnames";
  import { Grid } from "$lib/components/organisms/Layout";
	import ContentfulImage from "$lib/components/atoms/Image/ContentfulImage.svelte";

  export let image = null;

  export let thematic: {
    image: string,
    srcset: string,
    imageAlt: string,
    name: string,
    quote: string
  };
</script>

<!-- Add route class to enable custom color -->
<section class="{classNames('hero-thematic brand-color', $$props.class)}">
  <div class="hero-grid">
    <div class="hero-image-wrapper">
      {#if image}
        <ContentfulImage
          {image}
          class="hero-image"
        />
      {:else}
        <img
          src={thematic.image}
          srcset={thematic.srcset}
          alt={thematic.imageAlt}
          class="hero-image"
        />
      {/if}
    </div>
    <div class="hero-title">
      <p class="hero-thematic-name">
        {thematic.name}
      </p>
      <h1 class="hero-thematic-title">
        {@html thematic.quote}
      </h1>
    </div>
  </div>
  <div class="hero-content">
    <Grid>
      <div class="hero-content-text">
        <slot />
      </div>
    </Grid>
  </div>
</section>

<style type="text/scss" lang="scss">
  .hero-thematic {
    --hero-height: 400px;
    @apply bg-transparent;
    @apply relative;
    @apply border-b border-gray-100;

    @screen md {
      --hero-height: 330px;
    }

    @screen lg {
      --hero-height: 400px;
    }

    .hero-grid {
      @apply grid grid-cols-default;
      @apply gap-x-grid-default;
      @apply w-full;
      @apply md:page-margin md:page-max-width;
      @apply bg-gray-50;

      @screen md {
        height: var(--hero-height);
      }

      &:before {
        content: '';
        @apply hidden;
        @apply md:block;
        @apply md:bg-gray-50;
        @apply md:absolute md:inset-0;
      }
    }

    .hero-thematic-name {
      @apply uppercase tracking-wider font-semibold;
      @apply text-gray-600 text-sm lg:text-base;
    }

    .hero-thematic-title {
      @apply text-2xl lg:text-6xl leading-snug md:leading-tighter;
      @apply text-gray-900 font-medium font-serif;
    }

    .hero-thematic-name + .hero-thematic-title {
      @apply mt-3;
    }

    .hero-title {
      @apply relative;
      @apply col-span-full;
      @apply page-margin py-6 md:p-0;
      @apply md:row-start-1 md:col-start-1 md:col-span-4 xl:col-span-4;
      @apply md:self-center;
    }

    .hero-image-wrapper {
      @apply relative;
      @apply col-span-full;
      @apply md:row-start-1 md:col-start-5 md:col-span-8;
      min-height: 160px;
      

      /** Fix aspect ratio plugin */
      // --tw-aspect-w: 2;
      // --tw-aspect-h: 1;
      // padding-bottom: calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%);

      > * {
        @apply absolute w-full h-full;
        @apply inset-0;
      }

      @screen md {
        /* Remove aspect ratio */
        padding-bottom: 0;
        min-height: 400px;
      }

      /* Bottom gradient in the mobile version */
      &:before {
        content: '';
        @apply md:hidden;
        @apply bg-gradient-to-t from-black to-transparent opacity-10;
        @apply absolute inset-x-0 bottom-0;
        @apply h-[60px];
        @apply z-1;
      }
    }

    .hero-content {
      @apply relative;
      @apply bg-white;
    }

    .hero-content-text {
      @apply col-span-full md:col-start-2 md:col-span-10;
      @apply py-6 md:py-8;
      @apply leading-relaxed;
    }
  }

  .hero-thematic :global(.hero-image) {
    @apply object-cover object-center;
    @apply w-full;
    min-height: 160px;

    @screen md {
      height: var(--hero-height);
      min-height: 400px;
    }
  }
</style>
